import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Debug = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => <BlockComponent context={context} key={blockKey} />);

    if (childBlocks.length > 0) {
        return (
            <category name='Debug Tools' id='debugTools' iconclass='category with-icon-paths snap-icon-debug_dual'>{/* NOSONAR */}
                <label text="Debug Tools"/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }
    
    return null;
};

Debug.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Debug;